// Класс для отправки POST-запросов к API Dadata.
import utils from "./utils";
import cookies from "./cookies";

export default class ApiRequest {
    constructor(url, params = {}, method = "POST") {
        this.url = url;

        // контрольное число для защиты от ботов
        const challenge = utils.calcChallenge(
            cookies.get("csrftoken"),
            Math.floor(Date.now() / 1000),
        );

        this.options = {
            method,
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };

        if (!(/^http:.*/.test(url) || /^https:.*/.test(url))) {
            this.options.headers["X-Challenge"] = challenge;
        }

        if ("token" in params) {
            this.options.headers.Authorization = `Token ${params.token}`;
        }

        if ("secret" in params) {
            this.options.headers["X-Secret"] = `Token ${params.secret}`;
        }

        if ("csrf" in params) {
            this.options.headers["X-CSRFToken"] = params.csrf;
        }
    }

    async send(request = false, onlyOK = true) {
        // При включенном onlyOK любой ответ от сервера, кроме 200 ОК,
        // считается ошибочным.
        try {
            if (request) {
                this.options.body = JSON.stringify(request);
            }
            const response = await fetch(this.url, this.options);

            if (onlyOK && response.status !== 200) {
                throw new Error(`${response.status} ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }

    async uploadFile(request, progressHandler) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            function sendReject() {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText,
                });
            }
            if (progressHandler !== undefined) {
                xhr.upload.onprogress = progressHandler;
            }

            xhr.open(this.options.method, this.url);

            if ("X-CSRFToken" in this.options.headers) {
                xhr.setRequestHeader("X-CSRFToken", this.options.headers["X-CSRFToken"]);
            }
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

            xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    sendReject();
                }
            };
            // eslint-disable-next-line func-names
            xhr.onerror = function () {
                sendReject();
            };

            xhr.send(request);
        });
    }
}
